import { addDays, format } from 'date-fns'

function escapeIcsText(value) {
  return String(value || '')
    .replace(/\\/g, '\\\\')
    .replace(/\n/g, '\\n')
    .replace(/,/g, '\\,')
    .replace(/;/g, '\\;')
}

function toUtcDateTime(date) {
  return format(date, "yyyyMMdd'T'HHmmss'Z'")
}

function toDateOnly(date) {
  return format(date, 'yyyyMMdd')
}

export function buildJobIcs({
  uid,
  summary,
  startDate,
  endDate,
  startDateTime,
  endDateTime,
  location,
  description,
}) {
  const now = new Date()
  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//WTR CRM//Job Calendar Export//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${escapeIcsText(uid)}`,
    `DTSTAMP:${toUtcDateTime(now)}`,
    `SUMMARY:${escapeIcsText(summary)}`,
  ]

  if (startDateTime && endDateTime) {
    lines.push(`DTSTART:${toUtcDateTime(startDateTime)}`)
    lines.push(`DTEND:${toUtcDateTime(endDateTime)}`)
  } else {
    const start = new Date(startDate + 'T12:00:00')
    const endBase = new Date((endDate || startDate) + 'T12:00:00')
    const endExclusive = addDays(endBase, 1)
    lines.push(`DTSTART;VALUE=DATE:${toDateOnly(start)}`)
    lines.push(`DTEND;VALUE=DATE:${toDateOnly(endExclusive)}`)
  }

  if (location) lines.push(`LOCATION:${escapeIcsText(location)}`)
  if (description) lines.push(`DESCRIPTION:${escapeIcsText(description)}`)

  lines.push('END:VEVENT', 'END:VCALENDAR')
  return lines.join('\r\n')
}

export function downloadIcs(icsText, filename) {
  const blob = new Blob([icsText], { type: 'text/calendar;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}

export function sanitizeIcsFilename(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-_]+/g, '-')
    .replace(/^-+|-+$/g, '')
}
